import React, { useEffect } from 'react'

import { isEmpty } from 'lodash'
import { Box } from '@material-ui/core'

import { Text } from '../'
import TextEditorTrail from './TextEditorTrail'

import useTrailStep from 'hooks/useTrailStep'

const PrivacyPolicyForm = () => {
  const { privacyPolicy, handleNext } = useTrailStep()

  useEffect(() => {
    if (!isEmpty(privacyPolicy)) handleNext()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isEmpty(privacyPolicy) && (
      <>
        <Text color="primary" fontSize="5vh" variant="h1">
          Aviso de Privacidade
        </Text>
        <Box my={3}>
          <Text fontSize="2.5vh" variant="h4" gutterBottom>
            Um aviso de privacidade é um documento que informa de forma clara e
            objetiva aos usuários como sua organização trata seus dados
            pessoais.
          </Text>
        </Box>
        <TextEditorTrail />
      </>
    )
  )
}

export default PrivacyPolicyForm
